import React, { Component } from 'react';

import GenericBlock from './GenericBlock';
import Icon from '../Icon';

import './Block.css'

class IconBlock extends Component {

    render() {
        return(
            <GenericBlock className={"block-icon "+ this.props.className} style={this.props.style}>
                <Icon icon={this.props.icon} size={100} />

                {this.props.children}
            </GenericBlock>
        );
    }

}

export default IconBlock;



// WEBPACK FOOTER //
// ./src/components/blocks/IconBlock.js